import { ApiClient } from "../../ApiClient";
import { GetPromotionDetailsResponse } from "../schema/GetPromotionDetailsResponse";
import { mapPromotionDetails } from "../../mappers/promotions/promotionDetailsMapper";
import { PromotionDetails } from "@/@types";

export const getPromotionDetails = async (slug: string): Promise<PromotionDetails> => {

    const client = ApiClient.getInstance()

    const response = await client.get<GetPromotionDetailsResponse>(`promotions/details/${slug}`)

    const mappedResponse = mapPromotionDetails(response.data)

    return mappedResponse;

}